/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 *  Generic request to upsert visualization settings for any audience and target combination.
 *  This request can be used to create or update settings based on the presence of an ID.
 *  Supports all combinations of AudienceType and TargetType enum values.
 */

/**
 *  Request to create visualization settings for a specific user and view.
 */

/**
 *  Represents a request to update the settings of a user view.
 *  This interface is used to encapsulate the necessary information for updating user view settings.
 */

/**
 *  Request to upsert multiple visualization settings for a user.
 *  Accepts a list of UserViewSettingsUpsertRequest objects with a maximum controlled by MAX_BATCH_REQUESTS configuration.
 */

/**
 *  Request to upsert visualization settings for a specific user and view.
 *  This request can be used to create or update settings based on the presence of an ID.
 */

/**
 *  Generic response object for visualization settings operations.
 *  This response can represent any combination of audience and target types,
 *  making it flexible for all supported settings configurations.
 */

/**
 *  Response object for visualization settings creation operations.
 *  <p>
 *  Note: This response object currently uses "UserView" naming which reflects the current
 *  implementation focus on user-specific view settings. In the future, we should consider
 *  adopting a more generic naming pattern when we expand support to potentially include:
 *  - Portal-wide settings that apply to specific views
 *  - User-specific settings that apply to entire visualization types
 *  - Other audience/target combinations beyond the current user+view scope
 *  </p>
 */

/**
 *  Response for batch upsert operations containing results for each individual request.
 *  Some operations may succeed while others may fail.
 */

/**
 *  Result of a single upsert operation within a batch request.
 *  Contains either a successful response or an error.
 */

export const BoardSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.BoardSettings';
export const GanttChartSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.GanttChartSettings';
export const ReportSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.ReportSettings';
export const TableSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.TableSettings';
export const GradientRuleTypename = 'com.hubspot.crm.visualization.settings.models.settings.table.models.highlight.rules.GradientRule';
export const createUserViewSettingsRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'createUserViewSettings',
  auth: 'app',
  fingerprint: 'MBXrl99NVo66glJn0Gcu3QkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateSettingsByIdRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'updateSettingsById',
  auth: 'app',
  fingerprint: 'gx2gfuF_j8K6glJn0Gcu3QkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEffectiveSettingsRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'getEffectiveSettings',
  auth: 'app',
  fingerprint: 'tthL6i0YVAxBpac6P8E-PQkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEffectiveSettingsBatchRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'getEffectiveSettingsBatch',
  auth: 'app',
  fingerprint: '-XXqeULGJNqQ46oSFUJIaQkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertSettingsRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'upsertSettings',
  auth: 'app',
  fingerprint: 'N9PZwGeUPSdBpac6P8E-PQkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertUserViewSettingsRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'upsertUserViewSettings',
  auth: 'app',
  fingerprint: 'Ls4M84S4mma6glJn0Gcu3QkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertUserViewSettingsBatchRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'upsertUserViewSettingsBatch',
  auth: 'app',
  fingerprint: 'tY0aAwrwTXGcEUEs4TmYCAkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSettingsByIdRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'deleteSettingsById',
  auth: 'app',
  fingerprint: 'kQiglCInriaOUe2e_r4XmQkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'M_uUtCekyni6glJn0Gcu3QkKY6NJBx47',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};